export default __webpack_public_path__ + "static/customer-experience-banner-96525e621d8aa76077a592b2561ff0b7.png";